import type {ReactElement} from 'react';
import {useMemo} from 'react';
import type {AiChatLogoButtonProps} from './ai-chat-logo-button.types';
import {ClickableDiv} from '@Components/clickable-div';
import {getAssetUrl} from '@Utils/s3.util';
import styles from './ai-chat-logo-button.module.scss';
import {noop} from '@Utils/general.util';

export function AiChatLogoButton({
  onClick,
  assetName = 'ai-chat-postermywall-logo-horizontal.png',
  alt = 'postermywall logo',
  className = '',
}: AiChatLogoButtonProps): ReactElement {
  const logoImage = useMemo(() => {
    return <img className={`_cursor-pointer ${styles.logo}`} src={getAssetUrl(assetName)} alt={alt} />;
  }, [assetName, alt]);

  return (
    <div className={`flex-row-align-center ${styles.buttonsContainer} ${className}`}>
      <ClickableDiv onClick={onClick ?? noop} className={'flex-row-align-center'}>
        {logoImage}
      </ClickableDiv>
    </div>
  );
}
